import { createAction } from '@reduxjs/toolkit';

export const setSelectedFilePermissionId = createAction(
  'projectGallery/set-selected-file-permission'
);

export const clearGalleryData = createAction(
  'projectGallery/clear-gallery-data'
);
